import type { TokenScope } from './types';

export const SUB_HEADING = 'text-xs font-bold tracking-wider text-muted-foreground uppercase';

export const TOKEN_SCOPES: { value: TokenScope; title: string; description: string }[] = [
  {
    value: 'mcp:read mcp:write',
    title: 'Read & Write',
    description: 'Query warehouses, view dashboards, and save dashboards',
  },
  {
    value: 'mcp:read',
    title: 'Read only',
    description: 'Query warehouses and view dashboards',
  },
  {
    value: 'mcp:read mcp:audiences',
    title: 'Read + audiences',
    description: 'Query warehouses and view dashboards. Build draft audiences and propose audience changes.',
  },
  {
    value: 'mcp:read mcp:write mcp:audiences',
    title: 'Read, write + audiences',
    description:
      'Query warehouses, view dashboards, and save dashboards. Build draft audiences and propose audience changes.',
  },
];

/** The scopes a new token may be given: the audience scopes only where the audience tools are on. */
export function tokenScopesFor(isMcpAudienceToolsEnabled: boolean): typeof TOKEN_SCOPES {
  return isMcpAudienceToolsEnabled ? TOKEN_SCOPES : TOKEN_SCOPES.filter((s) => !s.value.includes('mcp:audiences'));
}

function hasContextManage(scope: string): boolean {
  return scope.split(' ').includes('context:manage');
}

export function scopeLabel(scope: string): string {
  const baseScope = scope.replace(/\s*context:manage/, '');
  const title = TOKEN_SCOPES.find((s) => s.value === baseScope)?.title ?? baseScope;
  return hasContextManage(scope) ? `${title} + Context Hub` : title;
}

export function scopeBadgeVariant(scope: string): 'success' | 'warning' {
  return scope.includes('mcp:write') || scope.includes('mcp:audiences') || hasContextManage(scope)
    ? 'warning'
    : 'success';
}
